import React, { useState } from 'react';
import Routes from '../../../../routes/routes';
import { Link } from 'react-router-dom';
import MediaQuery from 'react-responsive';
import * as S from './style';
import { CTAOfferButton } from '../../../../common/styled-components/styled-components';
import Image from '../../../../../../app/js/components/loggedout/common/Image';
import VideoModal from '../../../main-section-video/videoModal';
import TwinklingStarAnimation from '../../../../common/animation/animation-components/TwinklingStarAnimation';
import { breakpoints } from '../../../../../../app/js/utils/responsive_utilities';

import MathIcon from "~images/sem/math_icon.svg";
import ElaIcon from "~images/sem/ela_icon.svg";
import AppleLogo from "~images/sem/apple_logo.svg";
import KidImage from "~images/sem/kid4.png";
import GradeIcon from "~images/sem/pkTo5.svg";
import AndroidStoreLogo from "~images/sem/android_store_logo.svg";
import PlayBtnLogo from "~images/sem/play_btn.svg";
import KidSafeLogo from "~images/sem/kid_safe_coppa.svg";
import WhiteWave from "~images/sem/wave-white.png";

import { deepCoveDark } from '../../../../../../app/js/components/loggedout/shared-styles/Colors';

const FirstFold = ({ settings, trackPromoPageEvents }) => {
  const [showVideoOverlay, setShowVideoOverlay] = useState(false);
  
  const onPlayClickHandler = () => {
    trackPromoPageEvents("Promo Page Interacted", { "clicked_on": "video_started" }, true);
    setShowVideoOverlay(true);
  }

  const videoOverlayCloseHandler = () => {
    setShowVideoOverlay(false);
    location.pathname = Routes.PURCHASE_ROUTE;
  }
  let ctaText = settings.trial_days? `Try SplashLearn free for ${settings.trial_days} days`:'Subscribe Now';
  return (
    <S.ContainerWrapper>
      <S.ContentWrapper>
        <S.LeftContainer>
          <S.BannerSection showBanner = {!!settings.offer_discount_text}>
            <S.LeftStarContainer>
              <TwinklingStarAnimation containerId="LeftStarAnimation" type={1} />
            </S.LeftStarContainer>
            <S.OfferBanner>
              <S.OfferDuration>Just for today</S.OfferDuration>
              <S.OfferStripe>
                <S.OfferStripeText>
                  {settings.offer_discount_text}
                </S.OfferStripeText>
              </S.OfferStripe>
            </S.OfferBanner>
            <S.RightStarContainer>
              <TwinklingStarAnimation containerId="RightStarAnimation" type={2} />
            </S.RightStarContainer>
          </S.BannerSection>
          <S.CourseOffering>MATH &amp; READING FOR PRE-K TO GRADE 5</S.CourseOffering>
          <S.HeadingText>Learn through fun games!</S.HeadingText>
          <S.ListContainer>
            <S.ListItem>Curriculum-aligned skills</S.ListItem>
            <S.ListItem>Designed by experts </S.ListItem>
            <S.ListItem>Builds learning confidence</S.ListItem>
          </S.ListContainer>
          <S.VideoSection onClick={() => onPlayClickHandler()}>
            <S.VideoText>Watch video</S.VideoText>
            <S.VideoPlayBtnContainer>
              <S.VideoPlayBtn>
                <Image src={PlayBtnLogo} />
              </S.VideoPlayBtn>
            </S.VideoPlayBtnContainer>
          </S.VideoSection>
          {showVideoOverlay && settings.offer_video &&
            <VideoModal videoSrc={settings.offer_video} videoOverlayCloseHandler={videoOverlayCloseHandler} trackPromoPageEvents={trackPromoPageEvents} />
          }
          <S.ButtonWrapper>
            <CTAOfferButton white={true} textColor={deepCoveDark} fontWeight="600" hoverColor="rgb(237, 237, 249)">
              <Link to={Routes.PURCHASE_ROUTE} onClick={() => trackPromoPageEvents("Promo Page Interacted", { 'clicked_on': 'CTA1' }, true)}>
                {ctaText}
          </Link>
            </CTAOfferButton>
          </S.ButtonWrapper>
          <S.App>
            <S.AppText>Also available on:</S.AppText>
            <S.AppStoreIcons>
              <Image src={AppleLogo} />
              <Image src={AndroidStoreLogo} />
            </S.AppStoreIcons>
          </S.App>

        </S.LeftContainer>
        <MediaQuery query={`(min-width: ${breakpoints.md}px)`}>
          <S.RightContainer>
            <S.GradeIcon>
              <Image src={GradeIcon} />
            </S.GradeIcon>
            <S.KidSection>
              <Image src={KidImage} />
            </S.KidSection>
          </S.RightContainer>
        </MediaQuery>
      </S.ContentWrapper>
      <S.BottomWave>
        <S.IconsContainer>
          <S.MathIcon>
            <Image src={MathIcon} />
          </S.MathIcon>
          <S.ElaIcon>
            <Image src={ElaIcon} />
          </S.ElaIcon>
        </S.IconsContainer>
        <Image src={WhiteWave} />
        <S.BottomSection>
          {/* [AI GENERATED CODE] KidSafe badge linked to membership page */}
          <S.KidSafe>
            <a href="https://kidsafe.com/member/splashlearn" target="_blank" rel="noreferrer" aria-label="Read about KidSafe seal program">
              <Image src={KidSafeLogo} />
            </a>
          </S.KidSafe>
          <S.BottomHeadingText> Trusted by millions</S.BottomHeadingText>
          <S.SubHeadingText>Over 40+ million children and 750,000 teachers love us</S.SubHeadingText>
        </S.BottomSection>
      </S.BottomWave>
    </S.ContainerWrapper>
  )
}

export default FirstFold;